import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function SuiRating_i_0_Template(rf, ctx) { if (rf & 1) {
    var _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 1);
    ɵngcc0.ɵɵlistener("mouseover", function SuiRating_i_0_Template_i_mouseover_0_listener() { var restoredCtx = ɵngcc0.ɵɵrestoreView(_r4); var i_r2 = restoredCtx.index; var ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.onMouseover(i_r2); })("click", function SuiRating_i_0_Template_i_click_0_listener() { var restoredCtx = ɵngcc0.ɵɵrestoreView(_r4); var i_r2 = restoredCtx.index; var ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.onClick(i_r2); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var i_r2 = ctx.index;
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("selected", ctx_r0.hoveredIndex >= i_r2 && !ctx_r0.isReadonly)("active", ctx_r0.value > i_r2);
} }
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, Directive, Input, Output, EventEmitter, HostBinding, HostListener } from "@angular/core";
import { customValueAccessorFactory, CustomValueAccessor } from "../../../misc/util/index";
var SuiRating = /** @class */ (function () {
    function SuiRating() {
        this.hoveredIndex = -1;
        this.value = 0;
        this.valueChange = new EventEmitter();
        this.maximum = 5;
        this.isReadonly = false;
        this._ratingClasses = true;
    }
    Object.defineProperty(SuiRating.prototype, "maximum", {
        get: function () {
            return this._maximum;
        },
        set: function (value) {
            this._maximum = +value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SuiRating.prototype, "icons", {
        get: function () {
            // tslint:disable-next-line:prefer-literal
            return new Array(this.maximum);
        },
        enumerable: true,
        configurable: true
    });
    SuiRating.prototype.onClick = function (i) {
        if (!this.isReadonly) {
            this.value = i + 1;
            this.valueChange.emit(this.value);
        }
    };
    SuiRating.prototype.onMouseover = function (i) {
        this.hoveredIndex = i;
    };
    SuiRating.prototype.onMouseout = function () {
        this.hoveredIndex = -1;
    };
    SuiRating.prototype.writeValue = function (value) {
        this.value = value;
    };
    /** @nocollapse */
    SuiRating.ctorParameters = function () { return []; };
    SuiRating.propDecorators = {
        "_ratingClasses": [{ type: HostBinding, args: ["class.ui",] }, { type: HostBinding, args: ["class.rating",] },],
        "valueChange": [{ type: Output },],
        "maximum": [{ type: Input },],
        "isReadonly": [{ type: HostBinding, args: ["class.read-only",] }, { type: Input },],
        "onMouseout": [{ type: HostListener, args: ["mouseout",] },],
    };
SuiRating.ɵfac = function SuiRating_Factory(t) { return new (t || SuiRating)(); };
SuiRating.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SuiRating, selectors: [["sui-rating"]], hostVars: 6, hostBindings: function SuiRating_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("mouseout", function SuiRating_mouseout_HostBindingHandler() { return ctx.onMouseout(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("read-only", ctx.isReadonly)("ui", ctx._ratingClasses)("rating", ctx._ratingClasses);
    } }, inputs: { maximum: "maximum", isReadonly: "isReadonly" }, outputs: { valueChange: "valueChange" }, decls: 1, vars: 1, consts: [["class", "icon", 3, "selected", "active", "mouseover", "click", 4, "ngFor", "ngForOf"], [1, "icon", 3, "mouseover", "click"]], template: function SuiRating_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, SuiRating_i_0_Template, 1, 4, "i", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx.icons);
    } }, directives: [ɵngcc1.NgForOf], styles: [".read-only[_nghost-%COMP%]   .icon[_ngcontent-%COMP%] {\n    cursor: auto\n}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SuiRating, [{
        type: Component,
        args: [{
                selector: "sui-rating",
                template: "\n<i class=\"icon\"\n   *ngFor=\"let icon of icons; let i = index\"\n   (mouseover)=\"onMouseover(i)\"\n   (click)=\"onClick(i)\"\n   [class.selected]=\"hoveredIndex >= i && !isReadonly\"\n   [class.active]=\"value > i\">\n</i>\n",
                styles: ["\n:host.read-only .icon {\n    cursor: auto\n}\n"]
            }]
    }], function () { return []; }, { valueChange: [{
            type: Output
        }], maximum: [{
            type: Input
        }], isReadonly: [{
            type: HostBinding,
            args: ["class.read-only"]
        }, {
            type: Input
        }], _ratingClasses: [{
            type: HostBinding,
            args: ["class.ui"]
        }, {
            type: HostBinding,
            args: ["class.rating"]
        }], onMouseout: [{
            type: HostListener,
            args: ["mouseout"]
        }] }); })();
    return SuiRating;
}());
export { SuiRating };
var SuiRatingValueAccessor = /** @class */ (function (_super) {
    __extends(SuiRatingValueAccessor, _super);
    function SuiRatingValueAccessor(host) {
        return _super.call(this, host) || this;
    }
    /** @nocollapse */
    SuiRatingValueAccessor.ctorParameters = function () { return [
        { type: SuiRating, },
    ]; };
SuiRatingValueAccessor.ɵfac = function SuiRatingValueAccessor_Factory(t) { return new (t || SuiRatingValueAccessor)(ɵngcc0.ɵɵdirectiveInject(SuiRating)); };
SuiRatingValueAccessor.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: SuiRatingValueAccessor, selectors: [["sui-rating"]], hostBindings: function SuiRatingValueAccessor_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("valueChange", function SuiRatingValueAccessor_valueChange_HostBindingHandler($event) { return ctx.onChange($event); });
    } }, features: [ɵngcc0.ɵɵProvidersFeature([customValueAccessorFactory(SuiRatingValueAccessor)]), ɵngcc0.ɵɵInheritDefinitionFeature] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SuiRatingValueAccessor, [{
        type: Directive,
        args: [{
                selector: "sui-rating",
                host: { "(valueChange)": "onChange($event)" },
                providers: [customValueAccessorFactory(SuiRatingValueAccessor)]
            }]
    }], function () { return [{ type: SuiRating }]; }, null); })();
    return SuiRatingValueAccessor;
}(CustomValueAccessor));
export { SuiRatingValueAccessor };

